module.exports = __webpack_public_path__ + "img/icons-counter_calls.24aef11f.svg";